import { datadogRum } from '@datadog/browser-rum';
// eslint-disable-next-line import/no-unresolved
import clientGlobals from 'client_cw_globals';

const IS_DD_RUM_ENABLED = clientGlobals.ddRumLoggingEnabled;

export const initDDrum = (version) => {
  if (IS_DD_RUM_ENABLED) {
    return datadogRum.init({
      applicationId: clientGlobals.ddRumApplicationId,
      clientToken: clientGlobals.ddRumClientToken,
      site: 'datadoghq.com',
      service: 'gladis',
      env: clientGlobals.appEnv,
      version,
      sessionSampleRate: Number(clientGlobals.ddRumSessionSampleRate) || 100,
      sessionReplaySampleRate: Number(clientGlobals.ddRumSessionReplaySampleRate) || 20,
      trackUserInteractions: clientGlobals.ddRumTrackUserInteractions,
      trackResources: clientGlobals.ddRumTrackResources,
      trackLongTasks: clientGlobals.ddRumTrackLongTasks,
      defaultPrivacyLevel: clientGlobals.ddRumDefaultPrivacyLevel,
    });
  }

  return null;
};

export const startLogging = () => {
  if (IS_DD_RUM_ENABLED) {
    datadogRum.startSessionReplayRecording();
  }
};

export const stopLogging = () => {
  if (IS_DD_RUM_ENABLED) {
    datadogRum.stopSessionReplayRecording();
  }
};
